import { createEntitySource } from 'serviceWorker/channelServers/entitySource';
import * as dbVisibleFieldsService from 'serviceWorker/db/visibleFields/visibleFieldsService';
import { visibleFieldContract } from 'shared/domain/visibleField/visibleFieldContract';
import { getAllCurrentVisibleFieldsPromise } from './getVisibleFieldsPromise';
import { visibleFieldsSync } from '.';

/** Visible fields of the selected project stored in IndexedDB. */
export const visibleFieldSource = createEntitySource({
  service: dbVisibleFieldsService,
  contract: visibleFieldContract,
  ...visibleFieldsSync,
  readAll: getAllCurrentVisibleFieldsPromise,
});
